module.exports = __webpack_public_path__ + "img/1-3.88c90d86.webp";